import React from "react";

const Logo = () => {
    return (
        <svg
            className="logoNav"
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 900.000000 156.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <metadata>Created by potrace 1.10, written by Peter Selinger 2001-2011</metadata>
            <g transform="translate(0.000000,156.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path
                    d="M208 1384 c-59 -31 -58 -22 -58 -624 0 -608 -1 -594 62 -621 42 -18
183 -18 225 -1 62 27 63 35 63 490 l0 410 25 30 c46 54 127 48 165 -13 19 -31
20 -48 20 -446 1 -412 1 -414 23 -441 55 -66 250 -63 301 5 20 28 21 41 26
453 l5 424 27 26 c46 46 143 29 164 -29 4 -12 10 -212 13 -444 7 -490 -1 -456
114 -476 88 -15 172 1 205 38 l22 26 0 574 0 573 -35 31 -36 31 -230 0 c-248
0 -270 -4 -302 -53 -9 -14 -19 -47 -22 -74 -8 -53 -17 -70 -55 -96 -65 -45
-143 9 -155 108 -6 46 -13 60 -41 85 l-35 30 -232 0 c-186 -1 -237 -4 -259
-16z"
                />
                <path
                    d="M1888 1384 c-59 -31 -58 -22 -58 -623 0 -405 3 -557 12 -576 23 -51
56 -59 257 -63 302 -6 342 7 356 114 9 74 22 102 56 120 75 38 141 -4 153 -97
10 -79 34 -114 89 -128 59 -14 399 -15 452 0 22 6 50 20 63 32 l22 20 0 578 0
577 -35 31 c-34 30 -39 31 -126 31 -97 0 -136 -12 -163 -52 -14 -19 -16 -72
-16 -383 0 -216 -4 -375 -10 -397 -15 -54 -54 -81 -109 -75 -26 3 -52 13 -65
26 -21 21 -21 30 -26 409 -5 418 -6 424 -60 455 -37 22 -188 24 -229 3 -61
-32 -60 -28 -63 -451 l-3 -387 -34 -30 c-30 -27 -39 -30 -79 -25 -33 4 -50 12
-68 33 l-23 29 -1 378 c0 415 0 415 -60 451 -37 21 -193 22 -232 0z"
                />
                <path
                    d="M4374 1381 c-152 -55 -228 -144 -254 -298 -14 -88 0 -193 35 -263 27
-52 93 -123 134 -145 85 -43 112 -48 339 -54 l224 -6 29 -33 c33 -37 38 -79
13 -118 -35 -52 -48 -54 -391 -54 -278 0 -321 -2 -342 -16 -70 -49 -67 -204 5
-251 25 -16 58 -18 344 -21 390 -4 484 5 567 55 32 19 70 49 85 66 86 98 117
238 84 377 -19 79 -41 117 -105 180 -87 85 -120 93 -386 100 -141 3 -227 9
-241 17 -11 6 -28 27 -39 46 -21 40 -16 73 19 114 l24 28 334 5 c244 4 339 8
355 18 35 19 53 65 53 129 -1 66 -14 96 -56 124 -27 18 -49 19 -404 18 -335 0
-380 -2 -426 -18z"
                />
                <path
                    d="M5516 1370 l-36 -32 0 -577 0 -578 23 -21 c46 -43 192 -55 263 -21
47 23 54 50 54 213 0 85 5 166 12 188 22 74 88 98 153 58 41 -25 45 -45 45
-227 0 -207 18 -238 142 -250 89 -8 159 10 187 47 21 29 21 33 21 592 0 495
-2 566 -16 586 -27 39 -67 52 -160 52 -156 0 -174 -27 -174 -266 0 -169 -6
-190 -62 -217 -33 -16 -42 -17 -74 -5 -62 22 -74 62 -74 255 l0 163 -29 32
c-29 33 -30 33 -134 36 l-104 4 -37 -32z"
                />
                <path
                    d="M6870 1382 c-137 -42 -213 -115 -260 -248 -18 -54 -20 -82 -20 -368
0 -346 4 -375 69 -475 62 -95 151 -145 294 -162 105 -13 251 0 313 28 95 43
164 115 206 213 22 54 23 62 22 395 l0 340 -26 55 c-57 121 -127 183 -246 220
-83 26 -270 27 -352 2z m239 -296 c36 -28 41 -71 41 -324 0 -275 -5 -303 -58
-335 -39 -22 -59 -22 -99 3 -50 30 -55 62 -51 357 3 259 3 262 27 287 13 14
33 27 45 29 28 6 78 -3 95 -17z"
                />
                <path
                    d="M7766 1381 c-57 -38 -55 -22 -56 -612 0 -375 3 -556 11 -578 17 -48
58 -65 159 -66 167 0 180 18 180 254 l0 171 29 32 29 33 224 6 c261 7 299 17
395 99 153 132 159 430 11 572 -48 46 -83 66 -158 90 -49 16 -99 18 -425 18
-349 0 -372 -1 -399 -19z m679 -285 c33 -14 65 -59 65 -92 0 -30 -40 -82 -72
-93 -46 -16 -271 -14 -312 3 -68 28 -87 100 -41 155 31 36 39 38 198 40 90 1
138 -3 162 -13z"
                />
            </g>
        </svg>
    );
};

export default Logo;
